import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

export const useDeleteLog = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (logId: string) => {
			try {
				return (await api.delete(`/management/log/delete/${logId}`)).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao deletar log.');
			}
		},
		onSuccess: () =>
			Promise.all([
				queryClient.invalidateQueries({ queryKey: ['logs'] }),
				queryClient.invalidateQueries({ queryKey: ['log-metadata'] }),
			]),
		onError: (error) => {
			console.error('Erro ao deletar log:', getApiErrorMessage(error, 'Erro ao deletar log.'));
		},
	});
};
